var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoicePrint = function SvgVoicePrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 4.25h1.5v7.5h-1.5zm-3 2.25h1.5v3H.75zm6-6h1.5V14h-1.5zm3 1.5h1.5v13.5h-1.5zm3 2.25h1.5v7.5h-1.5zm3 2.25h1.5v3h-1.5z"
  })));
};
export default SvgVoicePrint;